import { Box, Pagination, Stack, Typography } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useStyles } from "./style";
import BrowseFilters from "../../components/browseFilters";
import SingleCard from "../../components/card/singleCard";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllArts } from "../../redux/arts/arts.action";
import loader from "../../assets/gifs/loading.gif";
import useScrollToTop from "../../components/scrollTop";
import { useLocation } from "react-router-dom";
import Loader from "../../components/loader";

const Browse = () => {
  const [page, setPage] = useState(1);
  const [tier, setTier] = useState(0);

  const dispatch = useDispatch();
  useScrollToTop();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const getTier = query.get("tier");

  const { AllArts, isAllArtsLoading, isAllArtsSuccess } = useSelector(
    (state) => state.arts
  );
  const [sortedData, setSortedData] = useState([]);
  const classes = useStyles();
  useEffect(() => {
    dispatch(getAllArts({ page, tier: tier }));
  }, [dispatch, page, tier]);

  useEffect(() => {
    setSortedData(AllArts.data);
  }, [AllArts]);
  const handlePagination = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };
  return (
    <Box className={classes.mainContainer}>
      <Box className={classes.filtersContainer}>
        {" "}
        <Box>
          <Typography color={"#fff"} variant="h3">
            {tier == 1 && "Tier One Tokens"}
            {tier == 2 && "Tier Two Tokens"}
            {tier == 3 && "Tier Three Tokens"}
            {tier == 4 && "Tier Four Tokens"}
            {tier == "All" && "All Tokens"}
          </Typography>
        </Box>
        <Box>
          <Box
            sx={{ backgroundColor: "#2D2342", margin: "15px 0px" }}
            className={classes.container}
          >
            <BrowseFilters
              setSortedData={setSortedData}
              data={AllArts.data}
              setTier={setTier}
            />
          </Box>

          <Box className={classes.mobileFilter}>
            <FilterAltIcon
              sx={{
                color: "#E3FF00",
                background: " #484848",
                borderRadius: "5px",
                fontSize: "40px",
              }}
            />
          </Box>
        </Box>
      </Box>

      <Box pt={3} className={classes.cardContainer}>
        {isAllArtsLoading ? (
          <Loader />
        ) : (
          <>
            {sortedData === "" ? (
              <>
                {" "}
                {AllArts.data &&
                  AllArts.data.map((items) => {
                    return <SingleCard {...items} />;
                  })}
              </>
            ) : (
              <>
                {" "}
                {sortedData &&
                  sortedData.map((items) => {
                    return <SingleCard {...items} />;
                  })}
              </>
            )}
          </>
        )}
      </Box>
      <Box
        py={4}
        sx={{
          color: "#fff !important",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Stack spacing={2}>
          <Pagination
            sx={{
              "& .MuiPaginationItem-root": {
                color: "#fff", // text color
                borderColor: "#fff", // if using outlined variant
              },
              "& .Mui-selected": {
                backgroundColor: "#fff !important",
                color: "#000", // selected text color
              },
              "& .Mui-active": {
                backgroundColor: "#fff !important",
                color: "#000", // selected text color
              },
            }}
            size="large"
            onChange={handlePagination}
            count={AllArts.totalPages}
            page={page}
            // variant="outlined"
            // shape="rounded"
          />
        </Stack>
      </Box>
    </Box>
  );
};
export default Browse;
